<template>
  <div>
    <div class="mb-2">
      Feature importance measures the impact of particular variables on the predictions for this race. A full listing by category is found in our
      <router-link :to="{ name: 'data_dictionary' }">data dictionary</router-link>.
    </div>
    <template v-for="(feat, index) in featureImportance">
      <div :key="index" class="variables" style="text-align: start; margin-left: 10px;">
        <span><b>{{feat[0]}}: </b></span>
        <span>{{feat[1]}}%</span>
      </div>
    </template>
  </div>
</template>

<script>
const props = {
  electionJson: {
    type: Object,
    required: true
  }
}

const computed = {
  featureImportance () {
    let features = []
    Object.entries(this.electionJson.featureImportance).forEach(item => {
      const arr = []
      arr[0] = item[0]
      arr[1] = parseFloat(item[1]).toFixed(2)
      features.push(arr)
    })
    features.sort((a, b) => { return b[1] - a[1] })
    return features
  }
}

export default {
  props,
  computed
}
</script>
